
<template>
  <el-dialog
    v-model="state.dialogVisible"
    title="修改密码"
    @close="handleModalClose"
    width="500px"
    :show-close="!props.config.force"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form ref="ruleForm" :model="form" label-width="120px" label-suffix="：">
      <el-form-item
        label="原密码"
        prop="originPsw"
        :rules="[
          {
            required: true,
            message: '请填写原密码',
            trigger: ['change', 'blur'],
          },
        ]"
      >
        <tm-password-input v-model="form.originPsw"></tm-password-input>
      </el-form-item>
      <el-form-item
        label="新密码"
        prop="newPsw"
        :rules="[
          {
            required: true,
            validator: checkPsw,
            trigger: 'change',
          },
        ]"
      >
        <tm-password-input v-model="form.newPsw"></tm-password-input>
      </el-form-item>
      <el-form-item
        label="确认新密码"
        prop="checkNewPsw"
        :rules="[
          {
            required: true,
            validator: checkNewPsw,
            trigger: ['change', 'blur'],
          },
        ]"
      >
        <tm-password-input v-model="form.checkNewPsw"></tm-password-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleModalClose" v-if="!props.config.force">取消</el-button>
        <el-button :loading="btn_loading" type="primary" @click="handleModalOk">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, inject, toRefs, ref } from "vue"
import dialog, { dialogProps } from "@/mixins/dialog"
import md5 from "js-md5"
import tmPasswordInput from "@/components/common/PasswordInput"
import store from "@/store"
import { useRouter } from "vue-router"
import { editPwd } from "@/api/systemUser"
const $router = useRouter()
const props = defineProps({
  ...dialogProps,
})

const $fetch = inject("$fetch")
const $tm_message_box = inject("$tm_message_box")

const ruleForm = ref(null)

const state = reactive({
  dialogVisible: false,
})
const form = reactive({
  originPsw: "",
  newPsw: "",
  checkNewPsw: "",
})
defineExpose({
  ...toRefs(state),
})
const { btn_loading } = dialog(form)
const checkPsw = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请输入新密码"))
  } else if (value == form.originPsw) {
    callback(new Error("新密码与原密码一致， 请重新设置"))
  } else if (!value.match(/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[\.!@#$%^&*_-]).{6,12}$/)) {
    callback(new Error("密码必须为英文字母、数字和符号的组合, 最短6位，最长12位"))
  } else {
    callback()
  }
}
const checkNewPsw = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请输入确认密码"))
  } else if (value !== form.newPsw) {
    callback(new Error("两次密码输入不一致"))
  } else {
    callback()
  }
}

const handleModalOk = () => {
  ruleForm.value.validate(valid => {
    if (valid) {
      const { newPsw, originPsw } = { ...form }
      editPwd({
        newPsw: md5(newPsw),
        originPsw: md5(originPsw),
      }).then(
        () => {
          $tm_message_box.toast("密码修改成功", { type: "success" })
          setTimeout(() => {
            store.dispatch("logout")
            $router.push("/login")
            props.ok()
          }, 1000)
        },
        () => {}
      )
    }
  })
}
// 关闭弹窗按钮
function handleModalClose() {
  state.dialogVisible = false
  props.close()
}
</script>

<style lang="less" scoped></style>
